export const ARCHE_ID = 'arche_contact_book';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;
